require("./gridDevices.scss");
// @vendor
const { connect } = require("react-redux");
const React = require("react");
const PropTypes = require("prop-types");
const classNames = require("classnames");
const { formatText, FormattedText } = require("core/i18n").i18n;
// @actions
const {
    requestSetAlias,
    requestSessionsByDevice,
    removeSessionsByDevice,
    requestInvalidateSession
} = require("actions/devices");
const {
    MODIFY_DEVICES_CC_ALIAS
} = require("constants/contactCenter/actionTypes");
const {
    getDevicesByKey,
    getIsFetchingDevicesByKey
} = require("selectors/devices");
// @components
const { Accordion } = require("commonsComponents/accordion");
const { AccordionBody } = require("commonsComponents/accordionBody");
const { AccordionHeader } = require("commonsComponents/accordionHeader");
const { OKButton } = require("components/commons/OKButton/OKButton");
const { OKLink } = require("commonsComponents/OKLink");
const { EmptyState } = require("commonsComponents/emptyState");
const { EditAlias } = require("commonsComponents/editAlias");
const { LoadingSection } = require("commonsComponents/loadingSection");
const { GridDevicesOptionsButton } = require("./gridDevicesOptionsButton");
const {
    GridDevicesSessionRowContent
} = require("./gridDevicesSessionRowContent");
const { GridDevicesImage } = require("./gridDevicesImage");
// const { DateText } = require('components/dateText/dateText');
// @resources
const exclamationIcon = require("assets/images/icon-exclamation-orange.svg");

// @utilities
const { formatDate } = require("utilities/dateHelper");
const { getDevicesKey } = require("utilities/devices");
const { recordLink } = require("utilities/tagging");

// @constants
const {
    UNKNOWN_DEVICES,
    BLOCKED_DEVICES,
    NORMAL_DEVICES,
    DEVICES_TO_SHOW
} = require("constants/index");

const {
    CHEVRON_CLOSE,
    CHEVRON_OPEN,
    DEVICES_CHEVRON,
    DEVICES_CLOSE,
    DEVICES_EDIT_NAME,
    DEVICES_INIT,
    DEVICES_SUCCESS,
} = require("constants/tagging.js");

class GridDevices extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            numberDevices: DEVICES_TO_SHOW
        };

        this.closeSession = this.closeSession.bind(this);
        this.handleToggleClick = this.handleToggleClick.bind(this);
        this.renderRow = this.renderRow.bind(this);
        // this.renderLastDuration = this.renderLastDuration.bind(this);
        this.renderState = this.renderState.bind(this);
        this.renderButtons = this.renderButtons.bind(this);
        this.renderDeviceName = this.renderDeviceName.bind(this);
    }

    closeSession(device) {
        device.sessions &&
            device.sessions[0] &&
            this.props.requestInvalidateSession(
                device.sid,
                device.sessions[0].sid
            );
        
        recordLink(DEVICES_CLOSE, DEVICES_SUCCESS);
    }

    accordionTagging = isExpanded => {
        !isExpanded
            ? recordLink(DEVICES_CHEVRON, CHEVRON_OPEN)
            : recordLink(DEVICES_CHEVRON, CHEVRON_CLOSE);
    };
    
    handleToggleClick(device) {
        const isExpanded = Array.isArray(this.props.sessions[device.sid]);

        (isExpanded
            ? this.props.removeSessionsByDevice
            : this.props.requestSessionsByDevice)(device.sid);

        this.accordionTagging(isExpanded);
    }

    renderTableHeader() {
        return (
            <div className="devices-grid__header row">
                <div className="devices-grid__header__cell col-xs-5 col-xs-offset-1">
                    {formatText("manageDevices-gridCellDevice")}
                </div>
                {/* <div className="devices-grid__header__cell col-xs-2">{formatText("manageDevices-gridCellPlace")}</div> */}
                <div className="devices-grid__header__cell col-xs-2">
                    {formatText("manageDevices-gridCellLastAccess")}
                </div>
                {/* <div className="devices-grid__header__cell col-xs-2">{formatText("manageDevices-gridCellDuration")}</div> */}
                <div className="devices-grid__header__cell col-xs-2">
                    {formatText("manageDevices-gridCellState")}
                </div>
                <div className="devices-grid__header__cell col-xs-2" />
            </div>
        );
    }

    renderImage(device) {
        return (
            device && (
                <div key="image" className="devices-grid__cell col-xs-1">
                    <div className="device-image-div">
                        <GridDevicesImage device={device} />
                    </div>
                </div>
            )
        );
    }

    renderDeviceName(device) {
        return (
            <div
                key="name"
                className="devices-grid__cell col-xs-5"
                onClick={() => recordLink(DEVICES_EDIT_NAME, DEVICES_INIT)}
            >
                <EditAlias
                    alias={device.alias}
                    postAlias={value => {
                        this.props.requestSetAlias(
                            device.sid,
                            value,
                            MODIFY_DEVICES_CC_ALIAS
                        );
                    }}
                    isHeading
                />
                {this.renderTrustedStatus(device)}
            </div>
        );
    }

    renderTrustedStatus(device) {
        return (
            device &&
            device.trusted && (
                <p className={"trusted-device"}>
                    {formatText("manageDevices-trustedDevice").toUpperCase()}
                </p>
            )
        );
    }

    renderLastConnection(device) {
        return (
            <div key="last-connection" className="devices-grid__cell col-xs-2">
                {device &&
                    device.sessions &&
                    device.sessions[0] &&
                    formatDate(device.sessions[0].fhStart).toLowerCase()}
            </div>
        );
    }

    showMoreDevicesUpdate = () => {
        const { showMore } = this.props;
        const typeDevice = this.getTypeDevice();

        this.setState(
            {
                numberDevices: this.state.numberDevices + DEVICES_TO_SHOW
            },
            () => {
                showMore(typeDevice, this.state.numberDevices);
            }
        );
    };

    renderState(device) {
        const text = formatText("manageDevices-modalCloseSessionText");
        const title = formatText("manageDevices-modalCloseSessionTitle", [
            device.alias
        ]);
        const buttonText = formatText("manageDevices-modalCloseSessionButton");
        const buttonAction = () => this.closeSession(device);
        const { openModal } = this.props;

        return (
            <div key="last-duration" className="devices-grid__cell col-xs-2">
                {device &&
                device.sessions &&
                device.sessions[0] &&
                device.sessions[0].active ? (
                    [
                        formatText("manageDevices-sessionActive"),
                        <OKButton
                            key="button"
                            modifier="link-complementary-block"
                            onClick={() =>
                                openModal(
                                    title,
                                    text,
                                    "",
                                    buttonText,
                                    "",
                                    buttonAction,
                                    recordLink(DEVICES_CLOSE, DEVICES_INIT)
                                )
                            }
                            size="small"
                        >
                            <FormattedText value="manageDevices-closeSession" />
                        </OKButton>
                    ]
                ) : (
                    <div>{formatText("manageDevices-sessionInactive")}</div>
                )}
            </div>
        );
    }

    renderButtons(device) {
        return (
            <div
                key="buttons"
                className="devices-grid__cell right-align col-xs-2"
            >
                {device && device.sessions && device.sessions[0] && (
                    <GridDevicesOptionsButton
                        openModal={this.props.openModal}
                        device={device}
                    />
                )}
            </div>
        );
    }

    getRowCells(device) {
        return [
            this.renderImage,
            this.renderDeviceName,
            // this.renderLocation,
            this.renderLastConnection,
            //this.renderLastDuration,
            this.renderState,
            this.renderButtons
        ].map(f => f(device));
    }

    renderRow(device) {
        const { sessions } = this.props;
        const isExpanded = Array.isArray(sessions[device.sid]);
        const accordionClassName = classNames("devices-grid__row", {
            "devices-grid__row--active": isExpanded
        });

        return (
            <Accordion
                key={device.sid}
                customClassName={accordionClassName}
                isExpanded={isExpanded}
                onClick={() => this.handleToggleClick(device)}
            >
                <AccordionHeader name="AccordionHeader" avoidOnClickOnChildren>
                    <div className="row">{this.getRowCells(device)}</div>
                </AccordionHeader>
                <AccordionBody name="AccordionBody">
                    <GridDevicesSessionRowContent device={device} />
                </AccordionBody>
            </Accordion>
        );
    }

    renderContent = () => {
        const { devices } = this.props;

        if (devices.length > 0)
            return (
                <div className="devices-grid__table">
                    {this.renderTableHeader()}
                    <div className="devices-grid__body">
                        {devices.map(this.renderRow)}
                    </div>
                </div>
            );

        const primaryText = formatText("manageDevices-noDevices");
        return (
            <div className="devices-grid__empty-state">
                <EmptyState
                    primaryText={primaryText}
                    iconType="search-banking"
                />
            </div>
        );
    };

    renderUnknownDisclaimer() {
        return (
            <div className="devices-grid__unknonw-disclaimer">
                <div className="devices-grid__unknonw-disclaimer__icon">
                    <img
                        className="devices-grid__unknonw-disclaimer__icon__img"
                        src={exclamationIcon}
                    />
                </div>
                <div className="devices-grid__unknonw-disclaimer__info">
                    <div className="devices-grid__unknonw-disclaimer__info__title">
                        {formatText(
                            "manageDevices-unknownDevicesDisclaimerTitle"
                        )}
                    </div>
                    <div className="devices-grid__unknonw-disclaimer__info__text">
                        {formatText(
                            "manageDevices-unknownDevicesDisclaimerDesc"
                        )}
                    </div>
                </div>
            </div>
        );
    }

    getTypeDevice = () => {
        const { blocked, unknown } = this.props;

        if (!blocked && !unknown) {
            return NORMAL_DEVICES;
        } else if (!blocked && unknown) {
            return UNKNOWN_DEVICES;
        } else if (blocked && !unknown) {
            return BLOCKED_DEVICES;
        }
    };

    buildShowMoreButton() {
        const { devices } = this.props;
        const { numberDevices } = this.state;

        if (numberDevices < devices.length) {
            return (
                <div className="devices-view__show-more-button">
                    <OKLink
                        onClick={() => this.showMoreDevicesUpdate()}
                        modifier="emphasize"
                    >
                        <FormattedText value="manageDevices-showMore" />
                    </OKLink>
                </div>
            );
        }
    }

    render() {
        const {
            devices,
            title,
            description,
            showEmpty,
            error,
            isFetching,
            unknown
        } = this.props;
        const primaryText = formatText("manageDevices-errorDevices");
        const showMoreButton = this.buildShowMoreButton();

        if (showEmpty && isFetching) return <LoadingSection />;

        if (error)
            return (
                <div className="devices-grid__empty-state">
                    <EmptyState
                        primaryText={primaryText}
                        iconType="nointernet-banking"
                    />
                </div>
            );

        return showEmpty || devices.length > 0 ? (
            <div className="devices-grid">
                {title && (
                    <div className="devices-grid__explanation">
                        <h1 className="devices-grid__explanation__title">
                            {title}
                        </h1>
                        <h4 className="devices-grid__explanation__text">
                            {description}
                        </h4>
                    </div>
                )}
                {unknown && this.renderUnknownDisclaimer()}
                {this.renderContent()}
                {showMoreButton}
            </div>
        ) : null;
    }
}

GridDevices.propTypes = {
    title: PropTypes.string,
    description: PropTypes.string,
    blocked: PropTypes.bool,
    devices: PropTypes.array,
    requestInvalidateSession: PropTypes.func,
    requestSessionsByDevice: PropTypes.func,
    removeSessionsByDevice: PropTypes.func,
    requestSetAlias: PropTypes.func,
    showMore: PropTypes.func,
    openModal: PropTypes.func,
    sessions: PropTypes.object,
    forgotten: PropTypes.bool,
    showEmpty: PropTypes.bool,
    error: PropTypes.object,
    isFetching: PropTypes.bool,
    unknown: PropTypes.bool
};

GridDevices.defaultProps = {
    title: "",
    description: "",
    devices: [],
    sessions: {},
    requestSetAlias: () => {},
    requestInvalidateSession: () => {},
    removeSessionsByDevice: () => [],
    openModal: () => null,
    showEmpty: false,
    error: null,
    isFetching: false,
    blocked: true,
    forgotten: false,
    unknown: false
};

const mapStateToProps = (state, ownProps) => ({
    devices: getDevicesByKey(
        state,
        ownProps.blocked,
        ownProps.forgotten,
        ownProps.unknown
    ).toJSON(),
    sessions: state.devices.get("sessions").toJSON(),
    error: state.devices.getIn([
        "errors",
        getDevicesKey(ownProps.blocked, ownProps.forgotten, ownProps.unknown)
    ]),
    isFetching: getIsFetchingDevicesByKey(
        state,
        ownProps.blocked,
        ownProps.forgotten
    )
});

const mapDispatchToProps = {
    requestSessionsByDevice,
    removeSessionsByDevice,
    requestInvalidateSession,
    requestSetAlias
};

module.exports.constructor = connect(
    mapStateToProps,
    mapDispatchToProps
)(GridDevices);
module.exports.GridDevices = connect(
    mapStateToProps,
    mapDispatchToProps
)(GridDevices);
